import { useContext } from 'react';
import AuthContext from '../context/AuthContext';

const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuth должен использоваться внутри AuthProvider');
  }
    const { user, login, logout, loading } = context;
  const isAuthenticated = !!user;

  return {
    user,
    login,
    logout,
    loading,
    isAuthenticated,
  };
};

export default useAuth;